module.exports = __webpack_public_path__ + "img/vip-img8-1.aa9e1dbd.png";